//filter desktop
document.addEventListener("DOMContentLoaded", () => {
  const productItems = document.querySelectorAll(".lens__item");
  const filterItems = document.querySelectorAll("#lens-filter li");
  const filterSelected = document.getElementById("filterSelected");
  const tryonTitle = document.querySelector(".list-title");
  const maxVisibleItems = 10;
  filterSelected.addEventListener("click", () => {
    filterDropdown.classList.toggle("open");
  });

  const updateVisibility = (filterTag) => {
    let visibleCount = 0;
    productItems.forEach((item) => {
      const itemTags = item.getAttribute("data-tags") || "";
      const matches =
        itemTags.includes(filterTag) || filterTag === "";

      if (matches && visibleCount < maxVisibleItems) {
        item.classList.add("show");
        item.classList.remove("hide");
        visibleCount++;
      } else {
        item.classList.remove("show");
        item.classList.add("hide");
      }
    });
  };

  filterItems.forEach((li) => {
    // Only attach click for items that have data-value
    if (li.hasAttribute("data-value")) {
      li.addEventListener("click", () => {
        // Update selected styling
        filterItems.forEach((el) => el.classList.remove("active"));
        li.classList.add("active");

        // Update filterSelected text
        filterSelected.textContent = li.textContent;

        // Update tryonTitle variable
        tryonTitle.textContent = li.textContent;

        // Filter products
        const filterTag = li.getAttribute("data-value");
        updateVisibility(filterTag);
        filterDropdown.classList.remove("open");
      });
    }
  });

  // Close dropdown if clicked outside
  document.addEventListener("click", (e) => {
    if (!filterDropdown.contains(e.target)) {
      filterDropdown.classList.remove("open");
    }
  });
});

//filter mobile
document.addEventListener("DOMContentLoaded", () => {
  const filterOpen = document.querySelector(".filter-open");
  const filterDropdown = document.querySelector(".filter-dropdown-mobile");
  const filterCloseBtn = document.querySelector(".filter-close");
  const filterApplyBtn = document.querySelector(".filter-apply");
  //const filterClearBtn = document.querySelector(".filter-clear");
  const filterListMobile = document.getElementById("lens-filter-mobile");
  const productItems = document.querySelectorAll(".lens__item");

  // 🔹 Function to show/hide lens items
  const updateVisibility = (filterTag) => {
    productItems.forEach((item) => {
      const itemTags = item.getAttribute("data-tags") || "";
      const isVisible =
        //filterTag === "best-seller" ||
        itemTags.includes(filterTag) ||
        filterTag === "";
      item.classList.toggle("show", isVisible);
      item.classList.toggle("hide", !isVisible);
    });
  };

  // 🔹 Click to select filter (just marks active)
  filterListMobile.addEventListener("click", (e) => {
    const li = e.target.closest("li[data-value]");
    if (!li || li.classList.contains("filter-heading")) return;
    filterListMobile.querySelectorAll("li[data-value]").forEach((el) => el.classList.remove("active"));
    li.classList.add("active");

    // Enable Apply button
    filterApplyBtn.classList.remove("disabled");
  });

  // 🔹 Apply filter and close dropdown
  filterApplyBtn.addEventListener("click", () => {

    // If button is disabled → do nothing
    if (filterApplyBtn.classList.contains("disabled")) return;

    const activeFilter = filterListMobile.querySelector("li.active");
    const filterTag = activeFilter ? activeFilter.getAttribute("data-value") : "";
    const filterText = activeFilter ? activeFilter.textContent.trim() : "Best Sellers";
    updateVisibility(filterTag);

    // 🔸 Update filter text span
  const filterTextSpan = document.querySelector(".filter-text");
  if (filterTextSpan) filterTextSpan.textContent = `: ${filterText}`;


    // Close filter dropdown
    filterDropdown.classList.remove("active");
    document.body.classList.remove("filterOpen");
  });

  // 🔹 Clear filter (show best-seller only)
  // filterClearBtn.addEventListener("click", () => {
  //   filterListMobile.querySelectorAll("li.active").forEach((el) => el.classList.remove("active"));
  //   //updateVisibility("best-seller");
  //   filterApplyBtn.classList.add("disabled");
  //   // Show all products
  //   productItems.forEach((item) => {
  //     item.classList.add("show");
  //     item.classList.remove("hide");
  //   });
  // });

  // 🔹 Open dropdown
  filterOpen?.addEventListener("click", () => {
    //console.log("test");
    filterDropdown.classList.add("active");
    document.body.classList.add("filterOpen");
  });

  // 🔹 Close dropdown (filter-close)
  filterCloseBtn?.addEventListener("click", () => {
    filterDropdown.classList.remove("active");
    document.body.classList.remove("filterOpen");
  });

  // 🔹 Initialize default view (best sellers)
  if (window.innerWidth > 991) {
    updateVisibility("best-seller");
  }
  filterApplyBtn.classList.add("disabled");
});

//image filter
document.addEventListener("DOMContentLoaded", () => {
  const eyeItems = document.querySelectorAll(".eye-item");
  const lensItems = document.querySelectorAll(".lens__item");
  const modelImage = document.querySelector(".tryon-model");
  const leftLabel = document.querySelector(".label.left");
  const rightLabel = document.querySelector(".label.right");
  const shopBtn = document.querySelector(".shop-btn"); // ⬅️ shop button
  const shopBtnSpan = shopBtn?.querySelector("span"); // 👈 inside span

  // Create loader
  const loader = document.createElement("div");
  loader.className = "tryon-loader";
  modelImage.parentElement.appendChild(loader);

  let selectedLens = document.querySelector(".lens__item.selected");

   // If default selected lens exists, update right label + button
  if (selectedLens) {
    const lensTitle = selectedLens.querySelector(".lens__title")?.textContent || "";
    const lensLink = selectedLens.getAttribute("data-link") || "#";
    if (rightLabel) rightLabel.textContent = lensTitle;
    if (shopBtn) shopBtn.setAttribute("href", lensLink);
    if (shopBtnSpan) shopBtnSpan.textContent = lensTitle;
  }

  // 🟤 1️⃣ Eye Color Click
  eyeItems.forEach((eye) => {
    eye.addEventListener("click", () => {
      // Set active
      eyeItems.forEach((e) => e.classList.remove("active"));
      eye.classList.add("active");

      // Update left label
      const spanText = eye.querySelector("span")?.textContent || "";
      if (leftLabel) leftLabel.textContent = spanText;

      // Update model image if a lens is already selected
      if (selectedLens) {
        updateModelImage(selectedLens, eye);

        // 🟩 Update shop button link
        const lensLink = lensToUse.getAttribute("data-link") || "#";
        if (shopBtn) shopBtn.setAttribute("href", lensLink);
        if (shopBtnSpan) shopBtnSpan.textContent = lensTitle;
      }
    });
  });

  // 🟢 2️⃣ Lens Click
  lensItems.forEach((lens) => {
    lens.addEventListener("click", () => {
      // Set selected
      lensItems.forEach((l) => l.classList.remove("selected"));
      lens.classList.add("selected");

      selectedLens = lens; // store currently selected lens

      // Update right label
      const lensTitle = lens.querySelector(".lens__title")?.textContent || "";
      if (rightLabel) rightLabel.textContent = lensTitle;

      // 🟩 Update shop button link
      const lensLink = lens.getAttribute("data-link") || "#";
      if (shopBtn) shopBtn.setAttribute("href", lensLink);
      if (shopBtnSpan) shopBtnSpan.textContent = lensTitle;

      // Update model image based on active eye
      const activeEye = document.querySelector(".eye-item.active");
      if (activeEye) updateModelImage(lens, activeEye);
    });
  });

  // 🔹 Function to update model image with fade + loader
  function updateModelImage(lens, activeEye) {
    if (!lens || !activeEye) return;

    let newImage = "";
    if (activeEye.classList.contains("data-light-brown")) {
      newImage = lens.dataset.lightBrown;
    } else if (activeEye.classList.contains("data-medium-brown")) {
      newImage = lens.dataset.mediumBrown;
    } else if (activeEye.classList.contains("data-dark-brown")) {
      newImage = lens.dataset.darkBrown;
    } else if (activeEye.classList.contains("data-green")) {
      newImage = lens.dataset.green;
    }

    if (newImage && modelImage) {
      loader.style.display = "block";
      modelImage.classList.add("fade-out");

      const tempImg = new Image();
      tempImg.src = newImage;
      tempImg.onload = () => {
        modelImage.src = newImage;
        loader.style.display = "none";
        modelImage.classList.remove("fade-out");
      };
    }
  }
});
